import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";

export default function Select(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options,
    size,
    required,
    fullWidth = true,
    error = null,
    showNA = false,
    className,
    iconColor = "#555",
    ...other
  } = props;

  return (
    <FormControl
      variant={variant || "outlined"}
      size={size || "small"}
      fullWidth={fullWidth}
      required={required}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={options.some((j) => j.id === value) ? value : ""}
        onChange={onChange}
        className={className}
        MenuProps={{
          PaperProps: {
            className: "bg-white border border-gray-500 !rounded-[10px]",
          },
        }}
        IconComponent={(e) => (
          <KeyboardArrowDownRounded
            {...e}
            sx={{ color: `${iconColor} !important` }}
          />
        )}
        {...(error && { error: true })}
        {...other}
      >
        {showNA && (
          <MenuItem value="">
            <em>N/A</em>
          </MenuItem>
        )}
        {options.map((item, index) => (
          <MenuItem key={index} value={item.id} disabled={item.disabled}>
            {item.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && (
        <FormHelperText className="error-color">{error}</FormHelperText>
      )}
    </FormControl>
  );
}
